import React, { useEffect } from "react";
import sectionImg from "../assets/imgs/team/teamsHeader.jpg";

// Import team member images
import team1 from "../assets/imgs/team/team-member-1.jpg";
import team2 from "../assets/imgs/team/team-member-2.jpg";
import team3 from "../assets/imgs/team/team-member-3.jpg";
import team4 from "../assets/imgs/team/team-member-4.jpg";
import team5 from "../assets/imgs/team/team-member-5.jpeg";

// Import team group images
import teamGroup1 from "../assets/imgs/team/team-group-1.jpg";
import teamGroup2 from "../assets/imgs/team/team-group-2.jpg";
import teamGroup3 from "../assets/imgs/team/team-group-3.jpg";
import teamGroup4 from "../assets/imgs/team/team-group-4.jpg";
import teamGroup5 from "../assets/imgs/team/team-group-5.jpg";
import teamGroup6 from "../assets/imgs/team/team-group-6.jpg";
import teamGroup7 from "../assets/imgs/team/team-group-7.jpg";
import teamGroup8 from "../assets/imgs/team/team-group-8.jpg";
import teamGroup9 from "../assets/imgs/team/team-group-9.jpg";
import teamGroup10 from "../assets/imgs/team/team-group-10.jpg";
import teamGroup11 from "../assets/imgs/team/team-group-11.jpg";
import teamGroup12 from "../assets/imgs/team/team-group-12.jpg";
import teamGroup13 from "../assets/imgs/team/team-group-13.jpg";
import teamGroup14 from "../assets/imgs/team/team-group-14.jpeg";
// import teamGroup15 from "../assets/imgs/team/team-group-15.jpeg";

const Team = () => {
    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    const teamMembers = [
        { img: team3 },
        { img: team2 },
        // { img: team4 },
        { img: team1 },
        { img: team5 }
    ];

    const teamGroups = [
        { img: teamGroup1 },
        { img: teamGroup2 },
        { img: teamGroup3 },
        { img: teamGroup4 },
        { img: teamGroup5 },
        { img: teamGroup6 },
        { img: teamGroup7 },
        { img: teamGroup8 },
        { img: teamGroup9 },
        { img: teamGroup10 },
        { img: teamGroup11 },
        { img: teamGroup12 },
        { img: teamGroup13 },
        { img: teamGroup14 },
        // { img: teamGroup15 }
    ];

    return (
        <>
            <main id="main">
                {/* Hero Section with Enhanced Styling */}
                <section
                    className="breadcrumbs-inner"
                    style={{
                        background: `linear-gradient(rgba(6, 35, 65, 0.9), rgba(6, 37, 68, 0.92)), url(${sectionImg}) center/cover no-repeat`,
                        minHeight: "400px",
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        overflow: "hidden"
                    }}
                    data-aos="zoom-out"
                >
                    <div
                        className="container"
                        style={{ position: "relative", zIndex: 2 }}
                    >
                        <h2
                            style={{
                                textAlign: "center",
                                color: "#fff",
                                fontSize: "3.5rem",
                                fontWeight: "700",
                                marginBottom: "1rem",
                                textShadow: "2px 2px 8px rgba(0,0,0,0.4)"
                            }}
                            data-aos="fade-right"
                        >
                            Our Team
                        </h2>
                        <div
                            style={{
                                height: "4px",
                                width: "100px",
                                // background: "linear-gradient(90deg, #9CC3D5FF, #fff)",
                                margin: "0 auto",
                                borderRadius: "2px"
                            }}
                            data-aos="fade-right"
                            data-aos-delay="100"
                        ></div>
                    </div>
                </section>

                {/* Enhanced Introduction Section */}
                <section
                    id="team"
                    className="team"
                    style={{
                        padding: "60px 0",
                        background: "linear-gradient(180deg, #f8f9fa 0%, #fff 100%)"
                    }}
                >
                    <div className="container" data-aos="fade-up">
                        <div
                            style={{
                                paddingTop: "40px",
                                position: "relative"
                            }}
                            className="section-title"
                        >
                            <div
                                className="col-lg-10 mx-auto p-4 p-lg-5 rounded-4"
                                style={{
                                    background: "#fff",
                                    boxShadow: "0 10px 30px rgba(15, 43, 82, 0.08)",
                                    border: "1px solid rgba(15, 43, 82, 0.1)"
                                }}
                            >
                                <p
                                    className="mb-0 text-center"
                                    style={{
                                        fontSize: "1.2rem",
                                        lineHeight: "1.8",
                                        color: "#2c3e50",
                                        fontWeight: "400"
                                    }}
                                >
                                    Finterk marketing runs along with the team of talented and experienced sales
                                    executives who are having diverse knowledge of the financial sector, and offering
                                    a perfect consultancy regarding loan facilities in the UAE.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Enhanced Management Team Section */}
                <section
                    className="team mx-auto"
                    style={{
                        background: "linear-gradient(135deg, #0f2b52 0%, #1a3d6b 100%)",
                        maxWidth: "1500px",
                        padding: "60px 45px 80px",
                        position: "relative",
                        overflow: "hidden"
                    }}
                >
                    <div
                        className="container"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        <div className="section-title text-center mb-5">
                            <h1
                                style={{
                                    color: "#fff",
                                    paddingTop: "0",
                                    fontSize: "2.8rem",
                                    fontWeight: "700",
                                    marginBottom: "1rem",
                                    position: "relative",
                                    display: "inline-block"
                                }}
                            >
                                Management Team
                                <span
                                    style={{
                                        position: "absolute",
                                        bottom: "-10px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        width: "120px",
                                        height: "4px",
                                        background: "linear-gradient(90deg, #9CC3D5FF, transparent)",
                                        borderRadius: "2px"
                                    }}
                                ></span>
                            </h1>
                            <p
                                style={{
                                    color: "rgba(255,255,255,0.8)",
                                    fontSize: "1.1rem",
                                    maxWidth: "600px",
                                    margin: "20px auto 0"
                                }}
                            >
                                Visionary leadership driving financial excellence
                            </p>
                        </div>

                        <div className="row justify-content-center g-4">
                            {teamMembers.map((member, index) => (
                                <div
                                    className="col-xl-3 col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-delay={`${(index + 1) * 100}`}
                                    key={index}
                                >
                                    <div
                                        className="member position-relative overflow-hidden rounded-4"
                                        style={{
                                            boxShadow: "0 15px 35px rgba(0,0,0,0.25)",
                                            transition: "all 0.3s ease",
                                            cursor: "pointer"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "translateY(-10px)";
                                            e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.3)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow = "0 15px 35px rgba(0,0,0,0.25)";
                                        }}
                                    >
                                        <img
                                            src={member.img}
                                            className="img-fluid"
                                            alt={`${member.name} - Fintrek marketing team`}
                                            style={{
                                                height: "500px",
                                                width: "100%",
                                                objectFit: "cover",
                                                transition: "transform 0.5s ease"
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                                        />
                                        <div
                                            className="position-absolute bottom-0 start-0 end-0 p-3"
                                            style={{
                                                background: "linear-gradient(transparent, rgba(15, 43, 82, 0.95))",
                                                color: "#fff",
                                                transform: "translateY(100%)",
                                                transition: "transform 0.3s ease"
                                            }}
                                        >
                                            <div className="d-flex justify-content-center">
                                                <div className="text-center">
                                                    <h5 className="mb-1" style={{ fontSize: "1.1rem" }}>Leadership</h5>
                                                    <p className="mb-0" style={{ fontSize: "0.9rem", opacity: 0.8 }}>Management Team</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Enhanced Meet The Full Team Section */}
                <section
                    className="full-team"
                    style={{
                        padding: "100px 0",
                        background: "linear-gradient(135deg, #9CC3D5FF 0%, #88b7cf 100%)",
                        position: "relative",
                        overflow: "hidden"
                    }}
                >
                    <div className="container" data-aos="fade-up">
                        <div className="section-title text-center mb-5">
                            <h2
                                style={{
                                    color: "#0f2b52",
                                    fontSize: "2.8rem",
                                    fontWeight: "700",
                                    marginBottom: "1rem",
                                    position: "relative",
                                    display: "inline-block"
                                }}
                            >
                                Meet Our Full Team
                                <span
                                    style={{
                                        position: "absolute",
                                        bottom: "-10px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        width: "120px",
                                        height: "4px",
                                        background: "linear-gradient(90deg, #0f2b52, transparent)",
                                        borderRadius: "2px"
                                    }}
                                ></span>
                            </h2>
                            <p
                                style={{
                                    color: "#2c3e50",
                                    fontSize: "1.2rem",
                                    maxWidth: "600px",
                                    margin: "20px auto 0",
                                    fontWeight: "400"
                                }}
                            >
                                Working together to provide the best financial solutions
                            </p>
                        </div>

                        <div className="row justify-content-center g-4">
                            {teamGroups.map((teamPhoto, index) => (
                                <div
                                    className="col-lg-4 col-md-6"
                                    data-aos="fade-up"
                                    data-aos-delay={`${(index + 1) * 100}`}
                                    key={index}
                                >
                                    <div
                                        className="team-photo-card h-100"
                                        style={{
                                            transition: "all 0.3s ease",
                                            cursor: "pointer"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "translateY(-8px)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                        }}
                                    >
                                        <div
                                            className="team-photo h-100"
                                            style={{
                                                borderRadius: "12px",
                                                overflow: "hidden",
                                                boxShadow: "0 12px 30px rgba(15, 43, 82, 0.18)",
                                                height: "100%"
                                            }}
                                        >
                                            <img
                                                src={teamPhoto.img}
                                                className="img-fluid w-100 h-100"
                                                alt={teamPhoto.title}
                                                style={{
                                                    height: "280px",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    transition: "transform 0.5s ease"
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.08)"}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                                            />
                                            <div
                                                className="position-absolute bottom-0 start-0 end-0 p-3 text-center"
                                                style={{
                                                    //   background: "linear-gradient(transparent, rgba(15, 43, 82, 0.7))",
                                                    //   color: "#fff",
                                                    //   transform: "translateY(100%)",
                                                    //   transition: "transform 0.3s ease"
                                                }}
                                            >
                                                {/* <p className="mb-0 small">Team Collaboration</p> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Added CTA Section */}
                        <div
                            className="text-center mt-5 pt-5"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            <div
                                className="d-inline-block p-4 px-5 rounded-4"
                                style={{
                                    background: "rgba(255,255,255,0.9)",
                                    backdropFilter: "blur(10px)",
                                    boxShadow: "0 10px 30px rgba(15, 43, 82, 0.15)"
                                }}
                            >
                                <h4
                                    style={{
                                        color: "#0f2b52",
                                        marginBottom: "1rem"
                                    }}
                                >
                                    Join Our Growing Team
                                </h4>
                                <p
                                    className="mb-3"
                                    style={{
                                        color: "#2c3e50",
                                        maxWidth: "500px"
                                    }}
                                >
                                    We're always looking for talented professionals to join our mission
                                </p>
                                <button
                                    className="btn px-4 py-2"
                                    style={{
                                        background: "#0f2b52",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "6px",
                                        fontWeight: "500",
                                        transition: "all 0.3s ease"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = "#1a3d6b";
                                        e.currentTarget.style.transform = "translateY(-2px)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = "#0f2b52";
                                        e.currentTarget.style.transform = "translateY(0)";
                                    }}
                                    onClick={() => window.location.href = "/vacancies"}
                                >
                                    View Career Opportunities
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};

export default Team;